import type { SyncAnnotationData, SyncEvent, SyncEventType } from '../types';
export function createSyncEvent(params: {
  taskID: string;
  videoId: string;
  type: SyncEventType;
  frameIndex: number;
  annotationId: string;
  annotation?: SyncAnnotationData;
}): SyncEvent {
  return {
    id: crypto.randomUUID(),
    taskID: params.taskID,
    type: params.type,
    videoId: params.videoId,
    frameIndex: params.frameIndex,
    annotationId: params.annotationId,
    payload: {
      annotation: params.annotation
    },
    createdAt: Date.now()
  };
}